module.exports = __webpack_public_path__ + "img/bs-10.220f0423.png";